const getAuthToken = (rootState) => rootState.auth.token;

export default getAuthToken;
